import React from 'react';
import FieldForm from '../../FieldForm/FieldForm';
import { FormControl } from 'react-bootstrap';
import { FieldTypeProps } from 'v2/common/DRM/CustomTab/Field/props';

const NumberField = (props: FieldTypeProps) => {
  const { fieldName, value } = props;

  return (
    <FieldForm
      {...props}
      content={value}
      renderInput={({ field: { onChange, ...field } }) => {
        return (
          <FormControl
            data-cy={`tab-field-${fieldName}-input`}
            id={fieldName}
            type="number"
            onChange={(e) => {
              if (String(e.target.value).length <= 255) {
                onChange(e);
              }
            }}
            {...field}
          />
        );
      }}
    />
  );
};

export default NumberField;
